import { useAppStateReducer } from '../AppState'
import { useWeb3ReactPlus } from '../Web3ReactPlus/Web3ReactPlusProvider'

export function useIsCardOpen(poolId: number) {
  const { chainId } = useWeb3ReactPlus()
  const [appState] = useAppStateReducer()
  if (!chainId) return false
  return appState[chainId]?.openPoolCard === poolId
}
